import settings from '@/settings'

let getCobrancas = (headers, data) => {
  let url = `${settings.apiPayment}/efi/cobranca/?status=CONCLUIDA`
  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let criarCobranca = (data, headers) => {
  return fetch(`${settings.apiPayment}/efi/cobranca/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

export default {
  getCobrancas,
  criarCobranca
}
